// extracted by mini-css-extract-plugin
export default {"taxonomy":"lsf-taxonomy","taxonomy__loading":"lsf-taxonomy__loading","taxonomy__new":"lsf-taxonomy__new","waiting":"lsf-waiting"};